import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={15}
      height={16}
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M10.223 6.81V4.68a.347.347 0 00-.346-.346H8.139v2.06a.188.188 0 01-.31.141l-.79-.685-.788.685a.188.188 0 01-.311-.141v-2.06H4.202a.347.347 0 00-.347.346v5.675c0 .191.156.346.347.346h4.17a2.47 2.47 0 01-.445-1.415 2.487 2.487 0 012.296-2.476zM4.79 8.514h1.658a.188.188 0 010 .375H4.79a.188.188 0 010-.375zM7.2 9.948H4.79a.188.188 0 010-.375H7.2a.188.188 0 010 .375z"
        fill="#E1AF00"
      />
      <Path
        d="M8.996 9.286c0 .78.635 1.416 1.415 1.416s1.416-.635 1.416-1.416a1.417 1.417 0 00-2.83 0zm1.603-.878v.69h.398a.188.188 0 110 .376h-.586a.188.188 0 01-.187-.188v-.878a.188.188 0 01.375 0z"
        fill="#E1AF00"
      />
      <Path
        d="M7.493 15.024c2.005 0 3.89-.781 5.308-2.199A7.458 7.458 0 0015 7.517c0-2.005-.78-3.89-2.199-5.308a7.464 7.464 0 00-8.6-1.44l.53.532a6.783 6.783 0 013.89-.49c1.4.233 2.674.89 3.681 1.897a6.756 6.756 0 011.992 4.81 6.756 6.756 0 01-1.992 4.808 6.756 6.756 0 01-4.809 1.992 6.756 6.756 0 01-4.809-1.992 6.804 6.804 0 01-.777-8.689.188.188 0 01.286-.025l.394.393.486-2.063-2.063.487.409.408c.065.066.073.17.018.244-2.172 2.957-1.85 7.146.748 9.744a7.458 7.458 0 005.308 2.199z"
        fill="#E1AF00"
      />
      <Path
        d="M7.2 9.572H4.788a.188.188 0 000 .375h2.41a.188.188 0 000-.375zM10.223 8.407v.879c0 .103.084.187.188.187h.585a.188.188 0 000-.375h-.398v-.691a.188.188 0 00-.375 0zM4.789 8.89h1.658a.188.188 0 000-.376H4.789a.188.188 0 000 .375z"
        fill="#000"
      />
      <Path
        d="M9.876 3.957H4.201a.723.723 0 00-.722.722v5.675c0 .398.324.722.722.722h4.49a2.475 2.475 0 001.72.693 2.487 2.487 0 002.483-2.483 2.487 2.487 0 00-2.296-2.476V4.68a.723.723 0 00-.722-.723zm-3.562.376h1.449V5.98l-.601-.522a.188.188 0 00-.246 0l-.602.522V4.333zM4.201 10.7a.347.347 0 01-.346-.347V4.68c0-.19.155-.346.346-.346H5.94v2.06a.188.188 0 00.31.141l.79-.685.789.685a.188.188 0 00.31-.141v-2.06h1.738c.191 0 .347.155.347.346v2.13a2.487 2.487 0 00-2.296 2.477c0 .525.164 1.013.444 1.415H4.2zm8.318-1.415a2.11 2.11 0 01-2.109 2.108 2.11 2.11 0 01-2.108-2.108 2.11 2.11 0 012.108-2.109 2.11 2.11 0 012.109 2.109z"
        fill="#E1AF00"
      />
    </Svg>
  );
}

export default SvgComponent;
